<div id="background-check" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2  bg-white">
    <div class="flex flex-col sm:w-auto md:hidden p-8">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
              <p>Driver’s license, social security, marital status, children and pets</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Residency History</h2>
              <p>Two years of residency history information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/residency" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Employment Information</h2>
              <p>Two years of employment information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/employment" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div *ngIf="verifastEnabled" class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Income & Identity</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/verifast" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled"  class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Verify Income</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/documents" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">{{currentApplicationStep}}/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Background Check</h2>
          </div>
        </div>
      </div>
      <form *ngIf="model" #termsForm="ngForm" class="flex flex-col pt-8">
        <div class="text-center">
          <p *ngIf="AddAdditionalApplicantKey == null">Tricon runs a background check on all completed
            applications.</p>
          <div>
            <mat-checkbox matInput name="Agree" id="Agree" required [(ngModel)]="model.AgreeToBackgroundCheck"
              #AgreeToBackgroundCheck="ngModel" binary="true" required></mat-checkbox>
            I agree to the <a class="text-vivid-blue hover:text-blue-800" href="{{ termsOfAgreementUrl }}"
              target="_blank">Terms and Conditions</a>
          </div>
          <p class="background-check" *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName == null">
            <br><br>Disclaimer: By checking this box you acknowledge that you have full authority under applicable law
            to agree to the background check on the behalf of the additional applicant.
          </p>
          <p class="background-check" *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName != null">
            <br><br>Disclaimer: By checking this box you acknowledge that you have full authority under applicable law
            to agree to the background check on the behalf of {{AddAdditionalApplicantName}}.
          </p>
        </div>
        <div *ngIf="model.RequiresIcraa">
          <div class="my-4">
            <div class="text-center">
              <p>California applicants are entitled to a copy of their investigative consumer reports. Review your rights here:
                <span class="text-vivid-blue" id="icraa-link" (click)="showInvestigativeConsumerReportDialog()">CA Civ. Code 1786.22</span>.
                Would you like to receive a copy?
              </p>
            </div>
            <div class="w-full mt-2">
              <mat-radio-group class="flex justify-around w-full" required [(ngModel)]="this.model.WantsInvestigativeConsumerReport" name="WantsInvestigativeReport">
                <mat-radio-button class="plan-radio-btn" [value]="true">Yes</mat-radio-button>
                <mat-radio-button class="plan-radio-btn" [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button mat-flat-button color="primary" class="h-10 px-6 my-2" (click)="cancelEdit()" class="h-10 px-6 my-2"
            *ngIf="AddAdditionalApplicantKey != null">CANCEL EDIT</button>

          <button mat-flat-button color="primary" class="h-10 px-6 my-2" (click)="onSubmit()"
            class="h-10 px-6 my-2 ml-2" [disabled]="!termsForm.form.valid || !model">CONTINUE</button>
        </div>
      </form>
    </div>
  </div>
</div>
